import axios from "axios";

const api = axios.create({
  baseURL: `http://localhost:5000`,
  withCredentials: true,
  maxContentLength: 500000000, // Adjust the value according to your needs
});

export default api;
